import { Document } from "models/schemas";
import { AtlasDocumentIngestion } from "pages/gaia-ai/definitions";
import { getFileNameWithoutExtension } from "utils/date-format";

export const adaptAtlasDocumentToDocument = (
  atlasDoc: AtlasDocumentIngestion,
): Document & {
  parsingStatus: string;
  ticketId?: string;
  reviewId?: string;
} => {
  const fileNameWithExtension = atlasDoc.documentUrl.split("/").pop() || "";
  const extensionType =
    `.${fileNameWithExtension.split(".").pop()?.toLowerCase()}` || "";

  return {
    documentId: atlasDoc.documentUrl,
    fileName: getFileNameWithoutExtension(fileNameWithExtension),
    documentType: "Atlas Document",
    extensionType: extensionType,
    size: atlasDoc.size,
    modifiedBy: atlasDoc.createdBy,
    modifiedAt: atlasDoc.createdAt?.toString(),
    createdBy: atlasDoc.createdBy,
    createdAt: atlasDoc.createdAt?.toString(),
    parsingStatus: atlasDoc.ingestionStatus || "Unknown",
    parentId: "",
    teamName: "",
    securityLevel: "Normal",
    deleted: false,
    s3Key: atlasDoc.documentUrl,
    externalUrl: undefined,
    ticketId: atlasDoc.ticketId,
    reviewId: atlasDoc.reviewId,
    isFolder: false,
  };
};
